import SalaryPageTemplate from "@/components/SalaryPageTemplate";
import { SALARY_DATA } from "@/data/salaryData";

export default function QAEngineerSalary() {
  return <SalaryPageTemplate data={SALARY_DATA["qa-engineer"]} />;
}
